import { render, staticRenderFns } from "./activity-dragon-order.vue?vue&type=template&id=baff29a8&scoped=true&"
import script from "./activity-dragon-order.vue?vue&type=script&lang=js&"
export * from "./activity-dragon-order.vue?vue&type=script&lang=js&"
import style0 from "./activity-dragon-order.vue?vue&type=style&index=0&id=baff29a8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baff29a8",
  null
  
)

export default component.exports